import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/img/advantage_1.svg'
import _imports_1 from '@/assets/img/advantage_2.svg'
import _imports_2 from '@/assets/img/advantage_3.svg'
import _imports_3 from '@/assets/img/advantage_4.svg'


const _hoisted_1 = { class: "advantages" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "wrapper" }
const _hoisted_4 = { class: "advantagesList" }
const _hoisted_5 = { class: "item" }
const _hoisted_6 = { class: "advantagesItem type1" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "img" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    alt: "advantage"
  })
], -1)
const _hoisted_8 = { class: "title font-prompt" }
const _hoisted_9 = { class: "item" }
const _hoisted_10 = { class: "advantagesItem type2" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "img" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_1,
    alt: "advantage"
  })
], -1)
const _hoisted_12 = { class: "title font-prompt" }
const _hoisted_13 = { class: "item" }
const _hoisted_14 = { class: "advantagesItem type3" }
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "img" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_2,
    alt: "advantage"
  })
], -1)
const _hoisted_16 = { class: "title font-prompt" }
const _hoisted_17 = { class: "item" }
const _hoisted_18 = { class: "advantagesItem type4" }
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "img" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_3,
    alt: "advantage"
  })
], -1)
const _hoisted_20 = { class: "title font-prompt" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _hoisted_7,
              _createVNode("span", _hoisted_8, _toDisplayString(_ctx.t("advantages.item1.title1")), 1),
              _createVNode("p", null, _toDisplayString(_ctx.t("advantages.item1.content")), 1)
            ])
          ]),
          _createVNode("div", _hoisted_9, [
            _createVNode("div", _hoisted_10, [
              _hoisted_11,
              _createVNode("span", _hoisted_12, _toDisplayString(_ctx.t("advantages.item2.title1")), 1),
              _createVNode("p", null, _toDisplayString(_ctx.t("advantages.item2.content")), 1)
            ])
          ]),
          _createVNode("div", _hoisted_13, [
            _createVNode("div", _hoisted_14, [
              _hoisted_15,
              _createVNode("span", _hoisted_16, _toDisplayString(_ctx.t("advantages.item3.title1")), 1),
              _createVNode("p", null, _toDisplayString(_ctx.t("advantages.item3.content")), 1)
            ])
          ]),
          _createVNode("div", _hoisted_17, [
            _createVNode("div", _hoisted_18, [
              _hoisted_19,
              _createVNode("span", _hoisted_20, _toDisplayString(_ctx.t("advantages.item4.title1")), 1),
              _createVNode("p", null, _toDisplayString(_ctx.t("advantages.item4.content")), 1)
            ])
          ])
        ])
      ])
    ])
  ]))
}